// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yg_U","left":"styles_left__39R_F","right":"styles_right__ebtUj","alert":"styles_alert__236Dm"};